
import { Component, Vue, Prop} from 'vue-property-decorator';
import { namespace } from "vuex-class";  

import PageBase from "../../PageBase.vue";
import SpouseSurvey from './SpouseSurvey.vue';
import Tooltip from "@/components/survey/Tooltip.vue";
 
import "@/store/modules/application";
const applicationState = namespace("Application");

import { stepInfoType, stepResultInfoType } from "@/types/Application";
import { stepsAndPagesNumberInfoType } from "@/types/Application/StepsAndPages";


@Component({
    components:{
      SpouseSurvey,
      PageBase,
      Tooltip
    }
})
export default class SpouseInfo extends Vue {

    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

    @applicationState.State
    public steps!: stepInfoType[];
    
    @applicationState.State
    public deceasedName!: string;

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void  

    currentStep =0;
    currentPage =0;
    
    showTable = true;
    spouseData = [];
    anyRowToBeEdited = null;
    editId = null; 
    incompleteError =  false;   
    spouseExists = null; 
    spouseCompleted = null;
    updated = 0;
    updatedSpouse = 0;
    showSeparatedInfo = false;
    showCommonLawInfo = false;
    showCommonLawOffInfo = false;
    showSpouseInfo = false;
    
    public openForm(anyRowToBeEdited?) {
        this.showTable = false;
         Vue.nextTick(()=>{
            const el = document.getElementById('spouse-info-survey')
            if(el) el.scrollIntoView();
        })
        if(anyRowToBeEdited) {
            this.editId = anyRowToBeEdited.id;
            this.anyRowToBeEdited = anyRowToBeEdited;
        } else {
            this.anyRowToBeEdited = null;
        }
    }

    public spouseComponentData(value) {       
        this.showTable = value;
    }

    public populateSurveyData(spouseValue) {

        const currentIndexValue = this.spouseData?.length > 0 ? this.spouseData[this.spouseData.length - 1].id : 0;
        const id = currentIndexValue + 1;
        const newSpouse = { ...spouseValue, id };
        this.spouseData = [...this.spouseData, newSpouse];

        this.showTable = true; 
        this.resetSpouseRelatedPages(this.spouseData);
    }

    public deleteRow(rowToBeDeleted) {
       
        this.spouseData = this.spouseData.filter(data => {
            return data.id !== rowToBeDeleted;
        }); 
        this.resetSpouseRelatedPages(this.spouseData);
        this.surveyHasError();
    }

    public editRow(editedRow) {
        this.spouseData = this.spouseData.map(data => {
            return data.id === this.editId ? editedRow : data;
        });
        this.showTable = true;
        this.surveyHasError();
        this.resetSpouseRelatedPages(this.spouseData);
    }

    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage()
    }

    public onNext() {
        if(!this.incompleteError)    
            Vue.prototype.$UpdateGotoNextStepPage()
    }

    created() {

        if (this.step.result?.spouseExists) {
            this.spouseExists = this.step.result.spouseExists;
        }

        if (this.step.result?.spouseSurvey?.data) {
            this.spouseData = this.step.result.spouseSurvey.data;
        }       
        
        if (this.step.result?.spouseCompleted) {
            this.spouseCompleted = this.step.result.spouseCompleted;
        }            
    }

    mounted(){
        this.updated = 0;
        Vue.nextTick(()=>this.surveyHasError());
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;        
    }

    public surveyHasError(){
        let progress = this.spouseData.length==0? 50 : 100;
        
        if(this.spouseExists == 'No') progress =100;

        this.incompleteError =  false;        
        for(const spouse of this.spouseData){
            if (!spouse.spouseName || !spouse.spouseIsAlive){            
                this.incompleteError = true;  
                progress = 50;    
                break
            }
        }        
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);
    }
    
    public isDisableNext() {
        return (this.spouseExists == null || (this.spouseExists == 'Yes' && this.spouseData?.length <= 0 ) || 
            !this.spouseCompleted || this.spouseCompleted == 'No');
    }

    beforeDestroy() {
        this.surveyHasError();  
        
        let spouseInfo = this.getSpouseResults();        
       
        if(this.spouseExists == 'No')
            spouseInfo = null

        this.UpdateStepResultData({step:this.step, data: {spouseExists: this.spouseExists, spouseSurvey: spouseInfo, spouseCompleted: this.spouseCompleted}})       
    }

    public getSpouseResults(){
        const questionResults: {name:string; value: any; title:string; inputType:string}[] =[];
        for(const spouse of this.spouseData)
        {
            questionResults.push({name:'spouseSurvey', value: this.getSpouseInfo(spouse), title:'Spouse '+spouse.id +' Information', inputType:''})
        }
        
        return {data: this.spouseData, questions:questionResults, pageName:'Spouse Information', currentStep: this.currentStep, currentPage:this.currentPage}
    }

    public getSpouseInfo(spouse){

        const resultString = [];
        resultString.push(Vue.filter('styleTitle')("Name: ")+spouse.spouseName);        
        resultString.push(Vue.filter('styleTitle')("Alive: ")+(spouse.spouseIsAlive=='y'?'Yes':'No'));
        if(spouse.spouseIsAlive=='y' && spouse.spouseIsAdult)
            resultString.push(Vue.filter('styleTitle')("Adult: ")+(spouse.spouseIsAdult=='y'?'Yes':'No'));
        
        return resultString;
    }  

    public resetSpouseRelatedPages(spouseData?) {
    //TODO
        // const stPgNo: stepsAndPagesNumberInfoType = this.$store.state.Application.stPgNo;   
        // const p = stPgNo.RFLM;

        // const pages = [ 
        //     p.ParentingArrangements,
        //     p.ParentalResponsibilities,
        //     p.ParentingTime,
        //     p.ParentingOrderAgreement,
        //     p.BestInterestsOfChild,
        //     p.ChildSupportCurrentArrangements,
        //     p.AboutChildSupportOrder,
        //     p.SpecialAndExtraordinaryExpenses,
        //     p.ContactWithChild,
        //     p.ContactWithChildOrder,
        //     p.AboutContactWithChildOrder,
        //     p.ContactWithChildBestInterestsOfChild,
        //     p.GuardianOfChild,           
        //     p.ReviewYourAnswersRFLM
        // ]
        // Vue.filter('setProgressForPages')(p._StepNo, pages,50);    

    }
}
